import { createReducer, on } from '@ngrx/store';
import { SimplePagesContainer } from '../domain/simple-page';
import * as Actions from './page-screen.actions';

export const featureKey = 'cxbPageScreen';

export interface FeatureState {
  pages: SimplePagesContainer;
  loading: boolean;
  isFilteringInProgress: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  pages: { genrePages: [], redeemPages: [], marketingPages: [], contentPages: [] },
  loading: false,
  isFilteringInProgress: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.loadCxbPageScreen, (state): FeatureState => ({ ...state, pages: { ...initialState.pages }, loading: true })),
  on(Actions.loadCxbPageScreenSuccess, (state, action): FeatureState => ({ ...state, pages: action.pages, loading: false })),
  on(Actions.loadCxbPageScreenFail, (state): FeatureState => ({ ...state, pages: { ...initialState.pages }, loading: false })),

  on(
    Actions.createCxbContentPage,
    Actions.createCxbRedeemPage,
    Actions.createCxbGenrePage,
    (state): FeatureState => ({ ...state, loading: true })
  ),
  on(Actions.createCxbPageFail, Actions.createCxbPageSuccess, (state): FeatureState => ({ ...state, loading: false }))
);
